<template>
  <div>
    <v-dialog
      v-model="isVisible"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      max-width="585"
      persistent
      scrollable
    >
      <v-card>
        <v-toolbar
          class="pl-1"
          flat
          height="80"
        >
          <v-avatar :color="$t('Restaurant.MenuStatusUpdateDialog.Toolbar.Color')">
            <v-icon dark>
              {{ $t('Restaurant.MenuStatusUpdateDialog.Toolbar.Icon') }}
            </v-icon>
          </v-avatar>

          <v-toolbar-title class="pl-3">
            <div class="body-3">
              {{ $t('Restaurant.MenuStatusUpdateDialog.Toolbar.Title') }}
            </div>

            <div class="text-caption">
              {{ $t('Restaurant.MenuStatusUpdateDialog.Toolbar.Subtitle') }}
            </div>
          </v-toolbar-title>

          <v-spacer />

          <v-btn
            icon
            @click="onCancelButtonClick"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-divider />

        <v-card-text
          class="pa-3"
        >
          <v-form
            ref="dialogForm"
            v-model="dialogFormValid"
            @submit.prevent
          >
            <v-container
              class="pa-0"
              fluid
            >
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="timeVal"
                    v-mask="'##:##'"
                    :hint="$t('Restaurant.MenuStockUpdateDialog.Field.Time.Hint')"
                    :label="$t('Restaurant.MenuStockUpdateDialog.Field.Time.Label')"
                    :placeholder="$t('Restaurant.MenuStockUpdateDialog.Field.Time.Placeholder')"
                    :prepend-icon="$t('Restaurant.MenuStockUpdateDialog.Field.Time.Icon')"
                    :rules="[
                      (v) => !!v || $t('Restaurant.MenuStockUpdateDialog.Field.Time.Error.Required'),
                      (v) => /^(2[0-3]|[01][0-9]):([0-5][0-9])$/.test(v) || $t('Restaurant.MenuStockUpdateDialog.Field.Time.Error.TimeString')
                    ]"
                    clearable
                  />
                </v-col>

                <v-col cols="auto">
                  <div class="text-caption mt-2">
                    {{ $t('Restaurant.MenuAddDialog.Field.Status') }}
                  </div>
                  <v-switch
                    v-model="statusVal"
                    :label="statusVal ? $t('Common.Button.Toggle.Active') : $t('Common.Button.Toggle.Inactive')"
                    class="mt-2"
                    color="success"
                    hide-details
                    inset
                  />
                </v-col>

                <v-col cols="auto">
                  <div class="text-caption mt-2">
                    {{ $t('Restaurant.MenuAddDialog.Field.VisibilityPos') }}
                  </div>
                  <v-switch
                    v-model="activePosVal"
                    :label="activePosVal ? $t('Common.Button.Yes') : $t('Common.Button.No')"
                    class="mt-2"
                    color="purple"
                    hide-details
                    inset
                  />
                </v-col>

                <v-col cols="auto">
                  <div class="text-caption mt-2">
                    {{ $t('Restaurant.MenuAddDialog.Field.Visibility') }}
                  </div>
                  <v-switch
                    v-model="activeVal"
                    :label="activeVal ? $t('Common.Button.Yes') : $t('Common.Button.No')"
                    class="mt-2"
                    color="blue"
                    hide-details
                    inset
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn
            class="light-blue--text text--darken-1"
            outlined
            @click="onCancelButtonClick"
          >
            {{ $t('Common.Button.Cancel').toLocaleUpperCase($i18n.locale) }}
          </v-btn>
          <v-btn
            class="green white--text elevation-0"
            @click="onSaveButtonClick"
          >
            {{ $t('Common.Button.Save').toLocaleUpperCase($i18n.locale) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AppData from '@/mixins/appdata'
import Auth from '@/mixins/auth'

export default {
  name      : 'MenuStatusUpdateDialog',
  components: {},
  mixins    : [AppData, Auth],
  props     : {
    visible: {
      type   : Boolean,
      default: false
    },
    data: {
      type   : Object,
      default: undefined
    }
  },
  data() {
    return {
      timeVal        : '',
      statusVal      : true,
      activeVal      : true,
      activePosVal   : true,
      dialogFormValid: false
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    isVisible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.timeVal = this.data?.data?.time || this.appConfig?.LOCATION_DATA?.Automation?.DailyOpen || ''
          this.statusVal = this.data?.data?.status ?? true
          this.activeVal = this.data?.data?.active ?? true
          this.activePosVal = this.data?.data?.activePos ?? true
        })
      }
    }
  },
  created() {
  },
  mounted() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  methods: {
    onSaveButtonClick() {
      this.$refs.dialogForm.validate()

      if (this.dialogFormValid) {
        if (this.$refs.dialogForm) this.$refs.dialogForm.resetValidation()

        this.$emit('save', {
          time     : this.timeVal,
          status   : this.statusVal,
          active   : this.activeVal,
          activePos: this.activePosVal
        }, this.data.dayIdx, this.data.timeIdx, this.data.week)

        this.onCancelButtonClick()
      }
    },

    onCancelButtonClick() {
      this.isVisible = false
      if (this.$refs.dialogForm) this.$refs.dialogForm.resetValidation()
      this.statusVal = this.activeVal = this.activePosVal = true
      this.timeVal = ''
    }
  }
}
</script>
